
import React, { useEffect, useMemo, useState } from "react";
import { API_BASE } from "../utils/draftutils";
import TreeCanvas from "../components/gerarchia/treecanvas";
import { collectSubtree, groupRoots } from "../utils/gerarchiautils";

const toNum = (v) => (v == null ? null : Number(v));

const adaptNodeFromApi = (n) => {
  // accetta sia camelCase che snake_case
  const rawId = toNum(n.id);
  const rawParent = toNum(n.idPadre ?? n.id_padre ?? null);
  const tipoFigli = n.tipoFigli ?? n.tipofigli ?? null; // "foglia" | "nonfoglia" | null

  const isLeafNode = tipoFigli == null;
  // id globale: prefisso per separare namespace
  const tempId = (isLeafNode ? `F-${rawId}` : `N-${rawId}`);
  const idPadre = rawParent == null ? null : `N-${rawParent}`;

  return {
    tempId,
    idPadre,
    isRadice: Boolean(n.isRadice ?? n.isradice ?? (rawParent == null)),
    nome: n.nome,
    campo: n.campo ?? null,
    tipoFigli,
    dominioVal: n.dominioVal ?? n.dominio_val ?? null,
    descrizione: n.descrizione ?? null,
    conversionFactor: n.fattore ?? n.conversionFactor ?? null,
  };
};

export default function VisualizzaGerarchie() {
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [nodes, setNodes] = useState([]);               // tutti i nodi
  const [selectedRootId, setSelectedRootId] = useState(null); // tempId della radice selezionata

  useEffect(() => {
  let alive = true;
  (async () => {
    setErr("");
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/gerarchia/visualnodes`, {
        credentials: "include",   
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      const adapted = (Array.isArray(data) ? data : []).map(adaptNodeFromApi);
      if (alive) setNodes(adapted);
    } catch (e) {
      if (alive) setErr("Errore nel caricamento: " + (e?.message || "sconosciuto"));
    } finally {
      if (alive) setLoading(false);
    }
  })();
  return () => { alive = false; };
}, []);

  // trova le radici
  const roots = useMemo(() => groupRoots(nodes), [nodes]);

  // imposta una radice di default quando arrivano i dati
  useEffect(() => {
    if (!roots.length) { setSelectedRootId(null); return; }
    // se non selezionato o non più valido -> prendi la prima radice
    if (!selectedRootId || !roots.some(r => r.tempId === selectedRootId)) {
      setSelectedRootId(roots[0].tempId);
    }
  }, [roots, selectedRootId]);

  // sottoalbero SOLO della radice scelta
  const selectedSubtree = useMemo(() => {
    const root = roots.find(r => r.tempId === selectedRootId);
    if (!root) return null;
    return { root, nodes: collectSubtree(nodes, root) };
  }, [roots, nodes, selectedRootId]);

  return (
    <div style={{ padding: 20 }}>
      <h2>LISTA SERVIZI</h2>

      {loading && <p>Caricamento…</p>}
      {err && <p style={{ color: "red" }}>{err}</p>}

      {!loading && !err && roots.length > 0 && (
        <div style={{ margin: "12px 0 20px" }}>
          <label>
            Scegli la gerarchia di <span style={{ fontWeight: "bold", color: "red" }}>servizi</span> da visualizzare:&nbsp;
            <select
              className="form-select mt-2"
              value={selectedRootId || ""}
              onChange={(e) => setSelectedRootId(e.target.value)}
            >
              {roots.map(r => (
                <option key={r.tempId} value={r.tempId}>{r.nome}</option>
              ))}
            </select>
          </label>
        </div>
      )}

      {!loading && !err && roots.length === 0 && (
        <p>Nessuna gerarchia trovata.</p>
      )}

      <hr className="my-4" />

      {selectedSubtree && (
        <section key={selectedSubtree.root.tempId} style={{ marginBottom: 48 }}>
          <h3 style={{ marginBottom: 8 }}>{selectedSubtree.root.nome}:</h3>
          <TreeCanvas
            all={selectedSubtree.nodes}
            root={selectedSubtree.root}
            readOnly={true}
            onAddChildren={() => {}}
            onRemove={() => {}}
            showConversions={true}
          />
        </section>
      )}
    </div>
  );
}
